import { Injectable } from '@angular/core';
import { TimeEntryInput } from '../../entities/timeEntry/timeEntry';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';
/**
 * The users service.
 */
@Injectable()
export class TimeEntryService {

  constructor(
    private apolloService: ApolloService
  ) {
  }
  
  /**
   * updates an user
   * @param userInput user Input
   * @param callback method
   */
  public updateTimeEntry(timeEntryInput: TimeEntryInput, callback: (arg: any) => void): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_TIME_ENTRY_MUTATION,
      {
        timeEntryInput: timeEntryInput,
      },
      callback
    );
  }
  /**
   * creates an user
   * @param userInput user Inout
   * @param callback method
   */
  public createTimeEntry(timeEntryInput: TimeEntryInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_TIME_ENTRY_MUTATION,
      {
        timeEntryInput: timeEntryInput,
      },
      callback
    );
  }
  
  public deleteTimeEntry(timeEntryId: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.DELETE_TIME_ENTRY_MUTATION,
      {
        timeEntryId: timeEntryId,
      },
      callback
    );
  }

}

